// Configuración centralizada de la aplicación
// Modifica estos valores para personalizar el nombre y logo de tu aplicación

export const AppConfig = {
    // Nombre de la aplicación
    name: "Laooal",
    shortName: "AppBase",

    // Logo de la aplicación
    logo: "/logo_cliente.png", // Logo principal (ubicado en /public)
    logoAlt: "Laooal Logo",

    // Logo para diferentes contextos
    logos: {
        main: "/logo_cliente.png",
        login: "/logo_cliente.png",
        header: "/logo_cliente.png",
        favicon: "/favicon.png"
    },

    // Información adicional
    version: "1.0.0",
    description: "Software de gestión de citas online laoal",

    // URLs externas (si aplica)
    website: "laooaldental.com",
    support: "clinicasllenas.com",
    documentation: ""
};
